/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import SchemeCommunity from './scheme-community';
import SchemeCommunityDetail from './scheme-community-detail';
import SchemeCommunityUpdate from './scheme-community-update';
import SchemeCommunityDeleteDialog from './scheme-community-delete-dialog';

const SchemeCommunityRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<SchemeCommunity />} />
    <Route path="new" element={<SchemeCommunityUpdate />} />
    <Route path=":id">
      <Route index element={<SchemeCommunityDetail />} />
      <Route path="edit" element={<SchemeCommunityUpdate />} />
      <Route path="delete" element={<SchemeCommunityDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SchemeCommunityRoutes;
